import React, { createContext, useContext, useEffect, useRef, useState } from 'react';

interface Size {
  width: number;
  height: number;
}

const SizeContext = createContext<Size>({ width: 0, height: 0 });

export const useSize = () => useContext(SizeContext);

interface ResizableContainerProps {
  children: React.ReactNode;
}

const ResizableContainer: React.FC<ResizableContainerProps> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<Size>({ width: 0, height: 0 });

  useEffect(() => {
    const handleResize = (entries: ResizeObserverEntry[]) => {
      if (entries[0].contentRect) {
        setSize({
          width: entries[0].contentRect.width,
          height: entries[0].contentRect.height,
        });
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <SizeContext.Provider value={size}>
      <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
        {children}
      </div>
    </SizeContext.Provider>
  );
};

export default ResizableContainer;